var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCotistion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.531,
    height: 20.454,
    viewBox: "0 0 20.531 20.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_76",
    "data-name": "Groupe 76",
    transform: "translate(-120.599 -439.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_140",
    "data-name": "Trac\\xE9 140",
    d: "M139.834,455.063V458.9h-3.8",
    fill: "none",
    stroke: "#e73c4c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_141",
    "data-name": "Trac\\xE9 141",
    d: "M132.067,458.9h-8.82a.9.9,0,0,1-.9-.9V445.961a.9.9,0,0,1,.9-.895h15.692a.9.9,0,0,1,.9.895v5.02",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    d: "M0,0H6.213A2.532,2.532,0,0,1,8.745,2.532v0A2.532,2.532,0,0,1,6.213,5.064H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(121.599 449.415)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_142",
    "data-name": "Trac\\xE9 142",
    d: "M139.834,445.066l-11.841-4.624-1.1,4.624h12.942",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_109",
    "data-name": "Ligne 109",
    y2: 5.064,
    transform: "translate(126.893 449.415)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotistion);
export default __webpack_public_path__ + "static/media/cotistion.9e7c805b87d811a850aee7f6cdef9352.svg";
export { ForwardRef as ReactComponent };